import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14041db5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "containerx doc-container text-right"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt fa-2x" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1rem"} }, " Delete", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-sm-12 document-wrapper" }
const _hoisted_7 = { class: "pdf-document" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "container"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-sm-12 document-wrapper" }
const _hoisted_12 = {
  key: 0,
  class: "button-group",
  style: {"z-index":"0"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

import { Document } from "@/models";
import { computed,PropType} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Floorplan',
  props: {
  floorplan: { type: Document, required: false },
  showdocument: {type: Boolean as PropType<boolean>, default: false, required: false},
  readonly: {type: Boolean as PropType<boolean>, default: false, required: false},
},
  emits: ['delete'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit

const onDelete = (event: Event) => {
  emit("delete", props.floorplan);
};

const fileicon = computed(() => {
  let icon = 'fa-file';
  let filextension = props.floorplan?.src?.toLocaleLowerCase();
  if (filextension?.endsWith("pdf")) {
    icon = 'fa-file-pdf';
  } else if (filextension?.endsWith("doc") || filextension?.endsWith("docx")) {
    icon = 'fa-file-word';
  } else if (filextension?.endsWith("jpg") || filextension?.endsWith("png")) {
    icon = 'fa-image';
  } else if (filextension?.endsWith("msg") || filextension?.endsWith("eml")) {
    icon = 'fa-envelope';
  }
  return icon;
});


return (_ctx: any,_cache: any) => {
  return (__props.showdocument)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-danger mb-2",
          onClick: _withModifiers(onDelete, ["stop"]),
          alt: "Delete"
        }, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (__props.floorplan && __props.floorplan.src)
                ? (_openBlock(), _createElementBlock("iframe", {
                    key: 0,
                    src: __props.floorplan.src,
                    style: {"height":"80vh","width":"100%","margin-bottom":"49px"},
                    frameborder: "0"
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _createElementVNode("i", {
                class: _normalizeClass(["far fa-4x", fileicon.value])
              }, null, 2)
            ]),
            (!__props.readonly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-danger",
                    onClick: _withModifiers(onDelete, ["stop"]),
                    style: {"padding":"0px 2px"}
                  }, _hoisted_14)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
}
}

})